// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-modal-info {
  height: 100vh;
  position: relative;
}

.header {
  background: url('primary-cart.png');
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-height: 35vh;
  max-height: 35vh;
}
@media (max-width: 400px) {
  .header {
    min-height: 32vh;
    max-height: 32vh;
  }
}
.header.vegan {
  background: url('green-cart.png');
  background-position: bottom;
  background-size: cover;
}
.header .back-img {
  position: absolute;
  top: 30px;
  left: 30px;
  width: 37px;
  height: 37px;
}
.header .cross-img {
  position: absolute;
  top: 38px;
  right: 30px;
  width: 22px;
  height: 22px;
}
.header .main-img {
  width: 60%;
  object-fit: contain;
}
@media (max-width: 400px) {
  .header .main-img {
    width: 55%;
    object-fit: contain;
    margin-top: -30px;
  }
}

.slide-col {
  display: flex;
  flex-direction: column;
  background-size: 100% 30vh !important;
  overflow: auto;
  height: 100%;
  scroll-behavior: smooth;
}

.option-group-col {
  flex: 1;
  overflow: auto;
  flex-shrink: 1;
  flex-basis: auto;
  padding: 15px 20px;
  max-height: 50px;
}
@media (max-width: 400px) {
  .option-group-col {
    overflow: none;
  }
}

.grow {
  flex-grow: 1;
  overflow: auto;
}

.info {
  padding: 30px 20px 0px;
}
@media (max-width: 992px) {
  .info {
    padding: 15px 20px 0px;
  }
}
.info .title {
  text-transform: uppercase;
  font-size: 26px;
  line-height: 30px;
  font-family: var(--font-tusker);
  color: var(--ion-color-secondary);
  margin-bottom: 6px;
  text-align: left;
}
@media (max-width: 400px) {
  .info .title {
    font-size: 20px;
    line-height: 24px;
  }
}
.info .desc {
  text-align: left;
  font-size: var(--modal-info-desc-font-size);
  line-height: var(--modal-info-desc-line-height);
}
.info .line {
  margin: 10px 0px;
  fill: var(--ion-color-primary);
  width: 100%;
}

ion-button .buuton-text {
  font-size: var(--modal-info-button-font-size);
  color: var(--modal-info-button-text-color);
  margin-right: 10px;
  font-family: Tusker, sans-serif;
}
ion-button .button-price {
  font-size: var(--modal-info-button-font-size);
  color: var(--modal-info-button-text-color);
  font-family: AppFontBold, sans-serif;
}

ion-toolbar {
  height: 75px;
  padding-right: 10px;
  display: flex;
  align-items: center;
  --background: url('menu_toolbar_background.svg') center bottom/105% no-repeat;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom;
}
ion-toolbar .toolbar-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
ion-toolbar h3 {
  padding-inline: unset !important;
  font-size: 20px;
  text-align: center;
  color: #fff;
  font-family: var(--font-tusker);
  text-transform: uppercase;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
ion-toolbar ion-button {
  --background: transparent;
  --background-activated: transparent;
  --background-focused: transparent;
  --background-hover: transparent;
}
ion-toolbar ion-icon {
  padding: 8px;
  font-size: 37px;
}

.option-group-description {
  line-height: 22px;
  font-size: 16px;
  text-align: left;
  text-transform: inherit;
  font-family: var(--font-tusker);
}

.info-product-icon {
  padding-left: 5px;
}

.circle-wrap {
  width: 25px;
  height: 25px;
}

.footer-button {
  padding: 20px;
}

swiper-container {
  width: 100% !important;
  height: auto;
}

swiper-slide {
  min-width: 80% !important;
  padding: 0px 20px;
  height: -moz-fit-content;
  height: fit-content;
  max-height: -moz-fit-content;
  max-height: fit-content;
}

.deposit_text {
  padding-top: 2px;
  font-size: 14px;
  font-family: Tusker, sans-serif;
  color: #878787;
  text-align: left;
}

.measurment_text {
  font-family: AppFont, sans-serif;
  font-size: 12px;
  color: #9f9f9f;
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/app/components/modal-info/modal-info.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,kBAAA;AADF;;AAIA;EACE,mCAAA;EACA,4BAAA;EACA,2BAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AADF;AAEE;EAXF;IAYI,gBAAA;IACA,gBAAA;EACF;AACF;AAAE;EACE,iCAAA;EACA,2BAAA;EACA,sBAAA;AAEJ;AAAE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AAEJ;AAAE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AAEJ;AAAE;EACE,UAAA;EACA,mBAAA;AAEJ;AAAI;EAJF;IAKI,UAAA;IACA,mBAAA;IACA,iBAAA;EAGJ;AACF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,cAAA;EACA,YAAA;EACA,uBAAA;AAEF;;AACA;EACE,OAAA;EACA,cAAA;EAIA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AADF;AALE;EAHF;IAII,cAAA;EAQF;AACF;;AAAA;EACE,YAAA;EACA,cAAA;AAGF;;AAGA;EAEE,sBAAA;AADF;AC7EE;ED4EF;IAII,sBAAA;EACF;AACF;AAAE;EAEE,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;AACJ;AAAI;EATF;IAUI,eAAA;IACA,iBAAA;EAGJ;AACF;AAAE;EAEE,gBAAA;EACA,2CAAA;EACA,+CAAA;AACJ;AACE;EACE,gBAAA;EACA,8BAAA;EACA,WAAA;AACJ;;AAME;EACE,6CAAA;EACA,0CAAA;EACA,kBAAA;EACA,+BAAA;AAHJ;AAME;EACE,6CAAA;EACA,0CAAA;EACA,oCAAA;AAJJ;;AAQA;EACE,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,6EAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;AALF;AAME;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAJJ;AAME;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EAEA,WAAA;EACA,+BAAA;EACA,yBAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AALJ;AAOE;EACE,yBAAA;EACA,mCAAA;EACA,iCAAA;EACA,+BAAA;AALJ;AAQE;EACE,YAAA;EACA,eAAA;AANJ;;AAUA;EACE,iBAAA;EAEA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,+BAAA;AARF;;AAWA;EACE,iBAAA;AARF;;AAUA;EACE,WAAA;EACA,YAAA;AAPF;;AAUA;EAGE,aAAA;AATF;;AAiBA;EACE,sBAAA;EAGA,YAAA;AAhBF;;AAmBA;EACE,yBAAA;EAEA,iBAAA;EAEA,wBAAA;EAAA,mBAAA;EACA,4BAAA;EAAA,uBAAA;AAlBF;;AAqBA;EACE,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,gBAAA;AAlBF;;AAoBA;EACE,gCAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAjBF","sourcesContent":["@import \"../../../theme/mixins\";\n\napp-modal-info {\n  height: 100vh;\n  position: relative;\n}\n\n.header {\n  background: url('../../../assets/tabilo/modal-info/primary-cart.png');\n  background-repeat: no-repeat;\n  background-position: bottom;\n  background-size: cover;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  min-height: 35vh;\n  max-height: 35vh;\n  @media (max-width:400px) {\n    min-height: 32vh;\n    max-height: 32vh;\n  }\n  &.vegan {\n    background: url('../../../assets/tabilo/modal-info/green-cart.png');\n    background-position: bottom;\n    background-size: cover;\n  }\n  .back-img {\n    position: absolute;\n    top: 30px;\n    left: 30px;\n    width: 37px;\n    height: 37px;\n  }\n  .cross-img {\n    position: absolute;\n    top: 38px;\n    right: 30px;\n    width: 22px;\n    height: 22px;\n  }\n  .main-img {\n    width: 60%;\n    object-fit: contain;\n\n    @media (max-width: 400px) {\n      width: 55%;\n      object-fit: contain;\n      margin-top: -30px;\n    }\n  }\n}\n\n.slide-col {\n  display: flex;\n  flex-direction: column;\n  background-size: 100% 30vh !important;\n  overflow: auto;\n  height: 100%;\n  scroll-behavior: smooth;\n}\n\n.option-group-col {\n  flex: 1;\n  overflow: auto;\n  @media (max-width:400px) {\n    overflow: none;\n  }\n  flex-shrink: 1;\n  flex-basis: auto;\n  padding: 15px 20px;\n  max-height: 50px;\n\n}\n\n.grow {\n  flex-grow: 1;\n  overflow: auto;\n}\n\n\n\n\n.info {\n\n  padding: 30px 20px 0px;\n  @include mobile {\n    padding: 15px 20px 0px;\n  }\n  .title {\n\n    text-transform: uppercase;\n    font-size: 26px;\n    line-height: 30px;\n    font-family: var(--font-tusker);\n    color: var(--ion-color-secondary);\n    margin-bottom: 6px;\n    text-align: left;\n    @media (max-width: 400px) {\n      font-size: 20px;\n      line-height: 24px;\n    }\n  }\n\n  .desc {\n\n    text-align: left;\n    font-size: var(--modal-info-desc-font-size);\n    line-height: var(--modal-info-desc-line-height);\n  }\n  .line {\n    margin: 10px 0px;\n    fill: var(--ion-color-primary);\n    width: 100%;\n  }\n}\n\n\n\nion-button {\n  .buuton-text {\n    font-size: var(--modal-info-button-font-size);\n    color: var(--modal-info-button-text-color);\n    margin-right: 10px;\n    font-family: Tusker, sans-serif;\n  }\n\n  .button-price {\n    font-size: var(--modal-info-button-font-size);\n    color: var(--modal-info-button-text-color);\n    font-family: AppFontBold, sans-serif;\n  }\n}\n\nion-toolbar {\n  height: 75px;\n  padding-right: 10px;\n  display: flex;\n  align-items: center;\n  --background: url(../../../assets/tabilo/menu_toolbar_background.svg) center bottom/105% no-repeat;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: bottom;\n  .toolbar-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n  h3 {\n    padding-inline: unset !important;\n    font-size: 20px;\n    text-align: center;\n    // margin-left: 50px;\n    color: #fff;\n    font-family: var(--font-tusker);\n    text-transform: uppercase;\n    word-break: break-word;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  ion-button {\n    --background: transparent;\n    --background-activated: transparent;\n    --background-focused: transparent;\n    --background-hover: transparent;\n  }\n\n  ion-icon {\n    padding: 8px;\n    font-size: 37px;\n  }\n}\n\n.option-group-description {\n  line-height: 22px;\n\n  font-size: 16px;\n  text-align: left;\n  text-transform: inherit;\n  font-family: var(--font-tusker);\n\n}\n.info-product-icon {\n  padding-left: 5px;\n}\n.circle-wrap {\n  width: 25px;\n  height: 25px;\n}\n\n.footer-button {\n  // position: fixed;\n  // bottom: 0px;\n  padding: 20px;\n  // margin: 0px;\n  // width: 100%;\n}\n.wrapper {\n  // height: 50%;\n}\n\nswiper-container {\n  width: 100% !important;\n  // min-height: 25vh;\n  // max-height: min-content;\n  height: auto\n}\n\nswiper-slide {\n  min-width: 80% !important;\n\n  padding: 0px 20px;\n\n  height: fit-content;\n  max-height: fit-content;\n\n}\n.deposit_text {\n  padding-top: 2px;\n  font-size: 14px;\n  font-family: Tusker, sans-serif;\n  color: #878787;\n  text-align: left;\n}\n.measurment_text {\n  font-family: AppFont, sans-serif;\n  font-size: 12px;\n  color: #9f9f9f;\n  text-align: left;\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
